module.exports = __webpack_public_path__ + "images/services/fogbugz.a1385c9ce999f8389ec7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/services/fogbugz.png
// module id = MV8P
// module chunks = 0